import makeRequestHeaders from '@src/utils/make-request-headers';

const updateLead = async ({
	leadId,
	language,
	sessionId = 'N/A',
}: {
	leadId: string;
	language: string;
	sessionId: string | undefined;
}) => {
	try {
		const response = await fetch(process.env.APP_PATH + '/api/clear-choice/update-lead/', {
			headers: makeRequestHeaders({
				sessionId,
			}),
			method: 'PATCH',
			body: JSON.stringify({
				leadId,
				language,
			}),
		});

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Failed Updating Lead');
		if (error instanceof Error) {
			console.error(error.message);
		}
		return [];
	}
};

export { updateLead };
